<template>
  <div>
    <div class="jumbotron">
      <div
        class="w-full h-full flex flex-col justify-center items-center text-center text-white inner px-3 md:pt-16"
      >
        <h1 class="text-4xl md:text-5xl pb-4 font-semibold">
          Looking for the next movie to watch?
        </h1>
        <p class="text-lg pb-3">
          Discover, organize and track thousands of movies.
        </p>
        <button-base :size="'text-xl'">
          <router-link to="/movies">Explore</router-link>
        </button-base>
      </div>
    </div>
    <!-- Section A -->
    <section class="bg-black py-8">
      <div class="container mx-auto">
        <div class="mb-16 text-center w-4/5 md:w-1/2 mx-auto">
          <h1
            class="text-3xl md:text-4xl mb-2 font-semibold md:leading-normal text-white"
          >
            There's a better way to discover.
          </h1>
          <p class="text-lg font-500 leading-relaxed mt-4 mb-4 text-gray-500">
            We’ve collected movie data from around the web so you don’t have to.
            Just tell us what kind of movies you’re looking for and we’ll give
            you the best there are.
          </p>
        </div>
        <img :src="bgLaptop" alt="big-screen" />
      </div>
    </section>

    <!-- Section B -->
    <section class="bg-black overflow-hidden h-full border-t">
      <div class="mx-auto pb-4">
        <div class="flex flex-wrap justify-center items-center">
          <div
            class="w-full md:w-2/5 px-12 md:px-4 pt-4 md:pt-0 lg:pl-32 ml-auto mr-auto md:mt-32"
          >
            <div
              class="text-gray-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white"
            />
            <h1 class="text-3xl mb-2 font-semibold leading-normal text-white">
              Grab your popcorn!
            </h1>
            <p
              class="text-base md:text-lg  font-500 leading-relaxed mt-4 mb-4 text-gray-500"
            >
              Now more than ever you need to relax, organize movies and share
              movies with the rest of the world, and <b>Mouvi</b> is the best
              medium for doing this.
            </p>
          </div>

          <div
            class="w-full md:w-3/5 px-4 mr-auto ml-auto relative md:h-400-px w-16 h-32"
          >
            <img
              :src="popcorn"
              alt="..."
              class="md:absolute right-0 opacity-75 md:-mt-16 rounded"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- Section C -->
    <section class="section-c relative">
      <div class="overlay"></div>
      <video
        :src="bgVideo"
        loop
        autoplay
        muted
        class="w-full h-full object-cover opacity-80"
      ></video>
      <div
        class="content z-10 absolute w-full px-4 h-full flex flex-col justify-center text-white"
      >
        <div
          class="mx-auto w-full md:w-3/5 xl:w-1/2 bg-black p-8 border-gray border"
        >
          <h1
            class="text-3xl md:text-4xl mb-2 font-semibold md:leading-normal text-white capitalize"
          >
            Never stop exploring new movies
          </h1>
          <p
            class="text-base md:text-lg font-500 leading-relaxed mt-4 mb-4 text-gray-500"
          >
            <span class="font-semibold">Mouvi</span> is a passion project
            created to help every movie lover find great recommendations for
            movies. With our awesome interface, you can create and share movie
            collections with friends.
          </p>
          <p
            class="text-base md:text-lg hidden lg:block font-500 leading-relaxed mt-4 mb-4 text-gray-500 pb-3"
          >
            You can build an enrich space for yourself by using our filter
            options to generate your favourite movie collections.
          </p>
          <button-base :size="'text-lg'"
            ><router-link to="/movies">Explore</router-link></button-base
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import bgLaptop from "@/assets/images/bg-laptop.png";
import popcorn from "@/assets/images/popcorn.jpg";
import bgVideo from "@/assets/media/bg-video.mp4";
import ButtonBase from "../components/Button/ButtonBase.vue";
export default {
  components: { ButtonBase },
  name: "Home",
  data() {
    return {
      popcorn,
      bgLaptop,
      bgVideo
    };
  }
};
</script>

<style lang="scss" scoped>
.jumbotron {
  position: relative;
  height: 550px;
  background: url("../assets/images/cinema-room.jpg");
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;

  .inner {
    position: relative;
    width: 100%;
    max-width: 640px;
    margin: auto;
    height: 100%;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.8) 0,
      rgba(0, 0, 0, 0) 60%,
      rgba(0, 0, 0, 0.8) 100%
    );
  }
}

.section-c {
  width: 100%;
  height: 500px;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    z-index: 1;
    mix-blend-mode: overlay;
  }

  .content {
    top: 0;
    left: auto;
  }

  video {
    object-fit: cover;
    opacity: 0.8;
  }
}
</style>
